import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SelectItem, TreeDragDropService } from "primeng/api";
import { MainMenuService } from "./main-menu.service";
import { IPageRoles, RoutesService } from "@main/routes";
import { IMainMenuItem } from "./main-menu-item";
import { IconSource } from "@features/bb-icon-dropdown/icon-source";

@Component({
    selector: "main-menu-item-edit",
    templateUrl: "main-menu-item-edit.component.html",
    providers: [TreeDragDropService],
    styleUrls: ["./main-menu-item-edit.component.scss"]
})
export class MainMenuItemEditComponent implements OnInit {
    private _menuItem: IMainMenuItem;

    @Input()
    set menuItem(item: IMainMenuItem) {
        this._menuItem = item;
        this.iconSourceSelected = !!item?.miproIcon ? IconSource.MiPro : IconSource.Material;
        this.enableSavingItemToDatabase = item.id <= 0;
    }
    get menuItem() {
        return this._menuItem;
    }

    @Output() readonly cancelNewItem = new EventEmitter<void>();
    @Output() readonly saveMenuItem = new EventEmitter<{ item: IMainMenuItem; saveToDatabase?: boolean }>();

    routes: IPageRoles[];
    customHandlersOptions = [<SelectItem>{ label: "Theme picker", value: "theme" }];

    iconSourceOptions = <SelectItem[]>[
        { label: "Material Icons", value: IconSource.Material },
        { label: "ORB Icons", value: IconSource.MiPro }
    ];
    iconSourceSelected = IconSource.Material;

    protected saveItemToDatabase = false;
    protected enableSavingItemToDatabase = false;

    constructor(private mainMenuService: MainMenuService, private routesService: RoutesService) {}

    ngOnInit() {
        this.routesService.getPageRoles().then(pages => {
            pages.sort((a, b) => a.title.localeCompare(b.title));
            this.routes = pages;
        });
    }

    get iconSources() {
        return IconSource;
    }

    get isNewItem(): boolean {
        return this.menuItem && !(this.menuItem.id > 0);
    }

    // === Menu Item Details ===
    titleByPath(path: string): string {
        const route = this.routeByPath(path);
        return route ? route.title : null;
    }

    routeByPath(path: string): any {
        return this.routes ? this.routes.find(o => o.path === path) : null;
    }

    onItemRouteChange(event) {
        this.menuItem.label = this.titleByPath(event.value);
    }

    onCancelNewItem() {
        this.cancelNewItem.emit();
    }

    onSaveMenuItem() {
        this.saveMenuItem.emit({ item: this.menuItem, saveToDatabase: this.enableSavingItemToDatabase && this.saveItemToDatabase });
    }
}
